<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <ul class="counties">
    <li v-for="(col, index) in columns" :key="index">
      <ul class="counties__list">
        <li>
          <div v-for="item in col" :key="item.id">
            <router-link :to="link(item)">
              <span>{{ item.name }}</span>
            </router-link>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
}

ul.counties {
  flex-wrap: wrap;

  & > li {
    display: flex;
    flex-direction: column;

    ul {
      flex-direction: row;
    }

    div {
      margin-bottom: 1em;
    }

    a {
      text-decoration: none;
    }
  }
}

ul.counties {
  & > li {
    flex: 1 1 33.333%;
    display: flex;
    flex-direction: column;

    &:nth-child(2) > ul {
      justify-content: center;
    }

    &:nth-child(3) > ul {
      justify-content: flex-end;
    }
  }
}

/*
@media (max-width: $responsive-break) {
  ul.counties {
    flex-direction: column;
  }
}
*/
</style>

<script>
export default {
  props: {
    items: Array,
    year: Number
  },

  methods: {
    link (item) {
      return this.countyLink(item.id, { year: this.year })
    }
  },

  data () {
    const columns = []
    const items = this.items

    for (let i = 0, modi = 0; i < items.length; i++) {
      modi = (i + 1) % 3
      if (typeof columns[modi] === 'undefined') {
        columns[modi] = []
      }

      columns[modi].push(items[i])
    }

    return {
      columns
    }
  }
}
</script>
